import React from 'react'

//CSS
import './Index.css'

//images
import img_1_1440x782 from '../../assets/images/img_1_1440x782.png'
import img_2 from '../../assets/images/img_2_1440x782.png'
import img_3 from '../../assets/images/img_3_1440x782.png'
// import img_4_1440x782 from '../../assets/images/img_4_1440x782.png'
// import img_4_1600x900 from '../../assets/images/img_4_1600x900.png'
// import img_4_1080x920 from '../../assets/images/img_4_1080x920.png'
import nuestrosClientes from '../../assets/images/nustros-clientes_06.png';

//MUI
import {
    Box, Button, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery
} from '@mui/material'
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';

//Components
import SecondForm from '../Form/Form'

//Router dom
import { Link, useNavigate } from 'react-router-dom'

//Custom button
const CustomButton = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#011E41',
    textTransform: 'none',
    fontWeight: '600',
    '&:hover': {
        backgroundColor: '#2F5A90',
    },
}));

const Index = () => {
    const navigate = useNavigate();

    const matchesTablet = useMediaQuery('(max-width: 991.5px)')
    const matchesMobile = useMediaQuery('(max-width: 500px)')
    const matchesSmallMobile = useMediaQuery('(max-width: 350px)')

    return (
        <>
            {/* <div className="content">
                <img
                    src={matchesMobile ? img_1_1080x920 : matchesTablet ? img_1_1600x900 : img_1_1440x782}
                    alt={matchesMobile ? img_1_1080x920 : matchesTablet ? img_1_1600x900 : img_1_1440x782}
                    className='content_image'
                />
                <div className='content_center'>
                    <Typography
                        sx={{
                            mb: 3,
                            fontSize: matchesSmallMobile ? '18px' : matchesMobile ? '22px' : matchesTablet ? '26px' : '50px'
                        }}
                    >
                        Tu aliado nacional en la creación de <span style={{ fontWeight: '900' }}>ambientes laborales seguros y saludables</span>
                    </Typography>
                    <CustomButton variant='contained' size="large" startIcon={<AddIcon />}>
                        Información
                    </CustomButton>
                </div>
            </div> */}
            <div className='content'>
                <Box
                    sx={{
                        position: 'relative',
                        height: matchesMobile ? '380px' : matchesTablet ? '500px' : '730px',
                        backgroundImage: `url(${img_1_1440x782})`,
                        backgroundSize: 'cover',
                        backgroundAttachment: matchesMobile ? 'scroll' : 'fixed',
                        backgroundPosition: 'center',
                        // objectFit: 'cover',
                        width: '100%',
                    }}
                >
                    <Box className='content_center'>
                        <Typography
                            sx={{
                                mb: 3,
                                fontSize: matchesSmallMobile ? '18px' : matchesMobile ? '22px' : matchesTablet ? '26px' : '50px',
                            }}
                        >
                            Tu aliado nacional en la creación de{' '}
                            <span style={{ fontWeight: '900' }}>ambientes laborales seguros y saludables</span>
                        </Typography>
                        <CustomButton variant='contained' size='large' startIcon={<AddIcon />}
                            onClick={ () => navigate('/servicios') }>
                            Información
                        </CustomButton>
                    </Box>
                </Box>
            </div>

            <Container maxWidth='xl' sx={{ mt: 6 }}>
                <Grid container alignItems="center" spacing={4} sx={{ py: 6 }}>
                    <Grid size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <Box
                            component="img"
                            src={img_2}
                            alt="Nuestros servicios"
                            sx={{
                                width: '100%',
                                height: 400,
                                objectFit: 'cover',
                                borderRadius: '8px',
                                boxShadow: 3,
                            }}
                        />
                    </Grid>

                    <Grid size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <Typography variant="h4" sx={{ fontWeight: 900, color: '#004A86', mb: 2 }}>
                            Nuestros servicios
                        </Typography>

                        <List dense>
                            {[
                                'Servicio médico inplant',
                                'Unidad móvil - campañas de salud',
                                'Exámenes periódicos (POE)',
                                'Insumos de salud',
                                'Estudios del ambiente laboral',
                            ].map((item) => (
                                <ListItem key={item} disableGutters>
                                    <ListItemIcon sx={{ minWidth: 32 }}>
                                        <CheckIcon sx={{ color: '#004A86' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item}
                                        primaryTypographyProps={{ fontSize: '1rem' }}
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Box sx={{ mt: 3 }}>
                            <CustomButton variant="contained" component={Link} to='/servicios'>Ver más</CustomButton>
                        </Box>
                    </Grid>
                </Grid>

                <Grid container alignItems="center" spacing={4} sx={{ py: 6 }}>
                    <Grid size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} order={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 2, xs: 2 }}>
                        <Typography variant="h4" sx={{ fontWeight: 900, color: '#004A86', mb: 2 }}>
                            Unidad Móvil
                        </Typography>
                        <Typography variant="subtitle1" color="text.secondary">
                            En Factor + Health entendemos que el tiempo de su equipo y el cumplimiento normativo son prioritarios.
                            Por ello, llevamos nuestros servicios de Unidad Médica Móvil directamente a su empresa para poder realizar
                            los estudios que su organización necesita para la vigilancia al personal ocupacionalmente expuesto, evitando
                            así riesgos a la salud o enfermedades de origen laboral.
                        </Typography>
                    </Grid>

                    <Grid size={{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} order={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                        <Box
                            component="img"
                            src={img_3}
                            alt="Unidad móvil"
                            sx={{
                                width: '100%',
                                height: 400,
                                objectFit: 'cover',
                                borderRadius: 2,
                                boxShadow: 3,
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
            <Container maxWidth='xxl' sx={{ mt: 8 }}>
                <Typography sx={{ fontWeight: '900', color: '#004A86', mb: 2, fontSize: matchesMobile ? '34px' : '38px' }} textAlign='center'>
                    Nuestros clientes
                </Typography>
                <img
                    src={nuestrosClientes}
                    alt="clientes-factor+health"
                    // src={matchesMobile ? img_4_1080x920 : matchesTablet ? img_4_1600x900 : img_4_1440x782}
                    // alt={matchesMobile ? img_4_1080x920 : matchesTablet ? img_4_1600x900 : img_4_1440x782}
                    width='100%'
                />
            </Container>
            <Container maxWidth='xl' sx={{ my: 8 }}>
                <Typography sx={{ fontWeight: '900', color: '#004A86', mb: 2, fontSize: matchesMobile ? '34px' : '38px' }} textAlign='center'>
                    Dudas y cotizaciones
                </Typography>
                <SecondForm type={'quote'} />
            </Container>
        </>
    )
}

export default Index